exports = module.exports = require("../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".image-wrapper[data-v-0a92df8e]{display:flex;align-items:center;justify-content:center}.image-wrapper figure[data-v-0a92df8e]{width:45%;max-width:320px}.image-wrapper figure img[data-v-0a92df8e]{box-shadow:0 4px 8px rgba(0,0,0,.2),0 6px 20px rgba(0,0,0,.19)}", ""]);
